import React, { useEffect, useState } from "react";
import { Alert, Button, Form, Input } from "antd";
import "antd/dist/antd.css";
import "../../css/users.css";
import { useLocation, useNavigate } from "react-router-dom";
import LeftSideNav from "../../components/LeftSideNav";
import { isPasswordValid } from "../../functions/commons";
import { isEmpty } from "lodash";
import { useResetPasswordMutation } from "../../store/appSlice";

function ResetPassword() {
  const layout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 12 },
      md: { span: 8 },
      lg: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 12 },
      md: { span: 12 },
      lg: { span: 12 },
    },
  };

  const navigate = useNavigate();
  const location = useLocation();

  const [input, setInput] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const [error, setError] = useState({
    newPassword: "",
    confirmPassword: "",
  });

  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isLoading, setLoading] = useState<boolean>(false);

  const [resetPassword] = useResetPasswordMutation();

  useEffect(() => {
    if (!isEmpty(errorMessage)) {
      setTimeout(() => {
        setErrorMessage("");
      }, 2000);
    }
  }, [errorMessage]);

  const validation = () => {
    const { newPassword, confirmPassword } = input;
    let newPasswordError = "";
    let confirmPasswordError = "";

    let valid = true;
    if (isEmpty(newPassword)) {
      valid = false;
      newPasswordError = "Password cannot be empty";
    } else if (!isPasswordValid(newPassword)) {
      valid = false;
      newPasswordError =
        "Password should contain atleast 8 characters, one upper case, one lower case, a number and a special character";
    } else if (newPassword !== confirmPassword) {
      valid = false;
      confirmPasswordError = "Password is not same";
    }

    setError({
      ...error,
      newPassword: newPasswordError,
      confirmPassword: confirmPasswordError,
    });

    return valid;
  };

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInput({
      ...input,
      [event.target.id]: event.target.value,
    });
  };

  const handleSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    if (validation()) {
      // if (true) {
      setLoading(true);

      const payload = {
        password: input.newPassword,
        uniqueKey: location.state.uniqueKey,
      };

      resetPassword(payload)
        .unwrap()
        .then((incomingData: any) => {
          setLoading(false);

          navigate("/auth/login", { replace: true });
        })
        .catch((err) => {
          setLoading(false);

          setErrorMessage(err?.data?.error?.message ?? "Something went wrong");
        });
    }

    console.log({ error });
  };

  const inputFormView = () => (
    <div style={{ marginLeft: 120 }}>
      <div className="signin-form-div">
        <h2>Reset Password</h2>
        <p>Enter a new password</p>

        {!isEmpty(errorMessage) && <Alert closable message={errorMessage} type="error" />}
        <Form {...layout} onFinish={handleSubmit}>
          <div className="sign-in__pswrd-frgt-pswrd">
            <h2>New Password</h2>
          </div>
          <Form.Item name="newPassword">
            <Input.Password
              type="password"
              value={newPassword}
              id="newPassword"
              onChange={handleOnChange}
              className="input_password_style"
              style={!isEmpty(error.newPassword) ? { borderColor: "red" } : {}}
            />

            {!isEmpty(error.newPassword) && (
              <div style={{ width: "450px" }}>
                <text style={{ color: "red" }}>{error.newPassword}</text>
              </div>
            )}
          </Form.Item>
          <div className="sign-in__pswrd-frgt-pswrd">
            <h2>Confirm Password</h2>
          </div>
          <Form.Item name="confirmPassword">
            <Input.Password
              type="password"
              value={confirmPassword}
              id="confirmPassword"
              onChange={handleOnChange}
              className="input_password_style"
              style={!isEmpty(error.confirmPassword) ? { borderColor: "red" } : {}}
            />

            {!isEmpty(error.confirmPassword) && (
              <text style={{ color: "red" }}>{error.confirmPassword}</text>
            )}
          </Form.Item>

          <Form.Item>
            <div style={{ marginTop: 20 }}>
              <Button type="primary" htmlType="submit" loading={isLoading} disabled={isLoading}>
                Submit
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </div>
  );

  const { newPassword, confirmPassword } = input;
  return (
    <div className="login_container">
      <div className="left-nav-col">
        <LeftSideNav />
      </div>
      <div className="inputform_container">{inputFormView()}</div>
    </div>
  );
}

export default ResetPassword;
